<!-- 比赛倒计时页面 -->
<template>
<div class="">
    <el-row>
        <el-tabs tab-position="left" style="width: 1000px;">
            <el-tab-pane label="设置时间">
                <el-row class="flex-row">                    
                    <el-col :span="2" :offset="4">
                        设置时间           
                    </el-col>
                    <el-col :span="10">
                        <el-input v-model="minute" placeholder="请输入比赛时间">
                            <template slot="append">分钟</template>
                        </el-input>
                    </el-col>
                </el-row>  
                <el-row class="flex-row">
                    <el-col :offset="4" style="margin-top: 50px;">
                        <el-button type="primary"  @click="submit">保存</el-button>
                        <el-button type="info"  @click="handleRest">重置</el-button>
                        <el-button type="danger" @click="toggleFullScreen">大屏</el-button>
                    </el-col>  
                </el-row>
                <el-row style="margin-top: 20px;">
                    <el-col :offset="4" class="red">
                        注意：请先设置时间，再设置背景图片
                    </el-col>
                </el-row>
            </el-tab-pane>  
            <el-tab-pane label="背景图片">
                <el-row class="flex-row" style="margin-bottom: 20px;">
                    <el-col :span="2" :offset="4">
                        选择颜色
                    </el-col>
                    <el-col :span="10">
                        <el-input type="color" v-model="colorValue" @change="selectColor"/>
                    </el-col>
                </el-row>
                <el-row class="flex-row mg-tb-20">
                    <el-col :span="2" :offset="4">
                        字体大小
                    </el-col>
                    <el-col :span="10">
                        <el-input v-model="fontNumber"></el-input>
                    </el-col>
                </el-row>
                <el-row class="flex-row img-bg">
                    <el-col :span="2" :offset="4">
                        背景图片
                    </el-col>
                    <el-col :span="10" >        
                        <el-upload  
                            ref="coverPicUpload" action="" 
                            list-type="picture" 
                            accept="image/*"
                            multiple :limit="1" name="file" 
                            :file-list="fileList"
                            :on-remove="handleRemove"
                            :http-request="handleRequest"
                            :before-upload="handleBeforeUpload"
                            >
                            <el-button size="small" type="primary">上传图片</el-button>                            
                        </el-upload>
                    </el-col> 
                </el-row>
                <el-row class="flex-row"> 
                    <el-col :offset="4">
                        <el-button type="primary"  @click="handleConfirm">保存</el-button>
                        <el-button type="danger" @click="toggleFullScreen">大屏</el-button>
                    </el-col>                    
                </el-row>
                <el-row style="margin-top: 20px;">
                    <el-col :offset="4">
                        <span class="red size18">注意：图片尺寸为1920*1080，大小不超过5M，换图片请先删除原图片，再重新上传</span>
                    </el-col>
                </el-row>
            </el-tab-pane>                     
        </el-tabs>
    </el-row>      
</div>
</template>
        <!-- <el-button type="primary"  @click="handlePlayStart" v-if="isShow">开始</el-button>
        <el-button type="info"  @click="handlePlayEnd"   v-else>停止</el-button> -->        
        <!-- <el-button type="info"  @click="handleRest">重置</el-button> -->
<script>
export default {
    props:{
        pubId:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            countdownTimer: null,
            minute: 50,
            countTime: null,
            isShow: true,
            flag: 1,
            imageUrl: '',
            fileList: [],
            colorValue:'#000',
            fontNumber: 200,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        handlePlayStart(){
            this.flag = 1
            this.isShow = !this.isShow
            clearInterval(this.countdownTimer);            
            if(this.flag){
                this.submit()
            }
        },
        handlePlayEnd(){
            this.flag = 2
            this.isShow = !this.isShow
            clearInterval(this.countdownTimer);
            if(this.flag){
                this.submit()
            }
        },
        handleRest(){
            this.flag = 3
            clearInterval(this.countdownTimer);
            this.isShow = true
            if(this.flag){
                this.submit()
            }
        },
        // 使用setInterval函数来实现倒计时30分钟
        countdown(){
            if(this.minute ===""){
                this.$message.error('请输入时间！')
                return false
            }
            var remainingTime = this.minute * 60; // 30分钟，以秒为单位
            var display = document.getElementById('timer'); // 页面上显示倒计时的元素
            
            this.countdownTimer = setInterval(()=> {
                var minutes = Math.floor(remainingTime / 60);
                var seconds = remainingTime % 60;
            
                // 在页面上更新倒计时显示
                this.countTime = minutes + ':' + (seconds < 10 ? '0' + seconds : seconds);
                if (remainingTime > 0) {
                    remainingTime--;
                } else {
                    clearInterval(this.countdownTimer); // 当倒计时结束时清除定时器
                }
            }, 1000); // 每隔一秒更新一次
        },  
        // 设置图片
        handleConfirm(){
            let params  = {
                opcode: this.$code.SetColorImage,
                i_serial_mark: this.pubId,
                i_image: this.imageUrl ,
                i_typeface: this.fontNumber,
                i_colour: this.colorValue
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success('设置成功')                                     
                }else{
                    this.$message.error(res.Message)
                }
            })
        },     
        submit(){
             // i_flag 1：开始；2：停止；3：复位；
            let params  = {
                opcode: this.$code.CountDownSet,
                i_serial_mark: this.pubId,
                timer: this.minute,
                i_timer: 0,               
                i_flag: this.flag,
                // i_image: this.imageUrl,
                // i_typeface: this.fontNumber,
                // i_colour: this.colorValue
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success('设置成功')
                    this.getTimeQuery()                    
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        getTimeQuery(){
            clearInterval(this.countdownTimer);
            let params = {
                opcode: this.$code.TimerQuery,
                i_serial_mark: this.pubId,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let list = res.Data.DataTable
                    let result = list.map(i=>{
                        return{
                            t: i['倒计时'],
                            status: i['状态'],
                            countImage: i['图片'],
                            color: i['颜色'],
                            fontSize: i['字体'],
                        }
                    })
                    if(result[0].countImage){
                        this.imageUrl = result[0].countImage
                        this.fileList = [{name: '', url: this.imageUrl }]
                    }
                    if(result[0].color){
                        this.colorValue = result[0].color
                    }
                    if(result[0].fontSize){
                        this.fontNumber = result[0].fontSize
                    }
                    let arr = result[0].t
                    let arr2 = arr.split(':')
                    if(Number(arr2[0]) > 0){
                        this.minuteSet = arr2[0]
                        this.secondSet = arr2[1]
                    }                    
                    this.countTime = result[0].t   
                    if(result[0].status === '开始'){
                        // this.isShow = false
                        // this.getCountdown()  
                    }     
                    if(result[0].status === '暂停' || result[0].status === '结束'){
                        clearInterval(this.countdownTimer)
                    }                        
                }else{
                    this.errorMsg = res.Message
                    clearInterval(this.countdownTimer)
                }
            })
        },
        getCountdown(){            
            var remainingTime = Number(this.minuteSet) * 60 + Number(this.secondSet); // 30分钟，以秒为单位
            var display = document.getElementById('timer'); // 页面上显示倒计时的元素
            
            this.countdownTimer = setInterval(()=> {
                var minutes = Math.floor(remainingTime / 60);
                var seconds = remainingTime % 60;
                
                // 在页面上更新倒计时显示
                this.countTime = minutes + ':' + (seconds < 10 ? '0' + seconds : seconds);
                if (remainingTime > 0) {
                    remainingTime--;
                } else {
                    clearInterval(this.countdownTimer); // 当倒计时结束时清除定时器
                }
            }, 1000); // 每隔一秒更新一次
        },    
        toggleFullScreen(){
            // this.$router.push({
            //     path: '/fullCountdown',
            //     query:{
            //         id: this.pubId
            //     }
            // })
            const routeUrl = this.$router.resolve({ name: 'fullcountdown', query: { id: this.pubId} });
            window.open(routeUrl.href, '_blank');   
        },  
        async handleRequest(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.imageUrl = this.$global.uploadUrl + url
            this.fileList = [{name:file.file.name,url: this.imageUrl }]
            console.log(this.imageUrl)
            // this.loading.close();
            // this.$refs.coverPicUpload.clearFiles()
        }, 
        handleRemove(file, fileList) {
            this.imageUrl = ''
            this.fileList = []
        },  
        selectColor(value){
            this.colorValue = value
        },
        handleBeforeUpload(file){
            // 在上传之前可以对文件进行校验  
            const isImage = file.type.startsWith('image/');  
            const isLt5M = file.size / 1024 / 1024 < 5;  
            if (!isImage) {  
                this.$message.error('上传文件只能是图片！');  
            }  
            if(!isLt5M){
                this.$message.error({
                    message : '上传图片大小不能超过5MB!',
                    duration: 4000
                });
            }
            return isImage && isLt5M
        }     
    },
    destroyed(){
        clearInterval(this.countdownTimer)
    }    
}
</script>
<style lang='scss' scoped>
.count{
    margin: 50px 0;
    font-size: 28px;
    // display: flex;
    // justify-content: center;
}
.timer{
    font-size: 80px;
    color: red;   
    margin-left: 30px;
}
.img-bg{
    height: 150px;
}
</style>


// WEBPACK FOOTER //
// src/views/team/components/countDown.vue